/*
document.addEventListener('_changeVariant', function(event) {
  //console.log('Variant change')
});
*/

/*
document.addEventListener('cartItems', function(event) {
  //console.log('Cart has been updated')
});
*/

// Variant image swap for collection card swatches
document.addEventListener('DOMContentLoaded', function() {
  function initVariantImgSwap(container) {
    container.querySelectorAll('.swatch-element:not(.advanced-filter)').forEach(function(s) {
      var input = s.querySelector('input.selector');
      if (!input) return;

      function swapImage() {
        var variantImg = input.getAttribute('data-variant-img');
        if (!variantImg) return;
        var group = input.getAttribute('data-group');
        var ptm = container.querySelector('.product-thumb-main[data-group="' + group + '"]');
        var img = ptm ? ptm.querySelector('img') : null;
        if (img) {
          img.src = variantImg;
          img.setAttribute('data-src', variantImg);
          img.srcset = variantImg;
          img.setAttribute('data-srcset', variantImg);
          img.classList.remove('lazyload');
          img.classList.add('lazyloaded');
          img.style.width = '100%';
          img.style.height = '100%';
          img.style.objectFit = 'contain';
          img.style.maxWidth = '100%';
          img.style.maxHeight = '100%';
        }
      }

      s.addEventListener('mouseenter', swapImage);
      input.addEventListener('click', swapImage);
    });
  }

  document.querySelectorAll('[data-section-type]').forEach(function(c) {
    initVariantImgSwap(c);
  });
});

// Mobile search icon → redirect to /search page
function initMobileSearch() {
  var ourBtn = document.querySelector('.ribble-mobile-search-btn');
  if (!ourBtn) return;
  ourBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/search';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileSearch);
} else {
  initMobileSearch();
}

// Ribble Main Cart — Free PE Top Banner
(function () {
  function initMainCartPEBanner() {
    var fleeceRows = document.querySelectorAll('[data-ribble-fleece-row="true"]');
    if (!fleeceRows.length) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fleeceQty = 0;
        var peTopQty = 0;
        cart.items.forEach(function (item) {
          if (item.handle === 'longridge-school-fleece') fleeceQty += item.quantity;
          if (item.handle === 'longridge-school-pe-t-shirt') peTopQty += item.quantity;
        });

        // Hide badge on fleece row
        document.querySelectorAll('[data-ribble-fleece-row="true"] .badge').forEach(function(el) {
          el.style.display = 'none';
        });

        // Hide strikethrough price on PE top row
        document.querySelectorAll('.item-row').forEach(function(row) {
          var link = row.querySelector('a[href*="longridge-school-pe-t-shirt"]');
          if (link) {
            var del = row.querySelector('h5.offers del');
            if (del) del.style.display = 'none';
          }
        });

        // PE top banner — inject before qty stepper inside PE top row
        if (peTopQty > 0) {
          document.querySelectorAll('.item-row').forEach(function(row) {
            var link = row.querySelector('a[href*="longridge-school-pe-t-shirt"]');
            if (link && !row.querySelector('.ribble-main-cart-petop-banner')) {
              var qtyOpt = row.querySelector('.qtyOpt.form');
              if (qtyOpt) {
                var peBannerHTML = '<div class="ribble-main-cart-petop-banner" style="display:inline-flex;align-items:center;gap:8px;padding:5px 0px;font-size:11px;font-weight:400;color:#1a1a1a;white-space:nowrap;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="#33CC66" style="flex-shrink:0"><path d="M21.41 11.58l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9A2 2 0 0 0 13 22a2 2 0 0 0 1.41-.59l7-7A2 2 0 0 0 21.41 11.58zM6.5 8A1.5 1.5 0 1 1 8 6.5 1.5 1.5 0 0 1 6.5 8z"/></svg>PE T-Shirt with Fleece</div>';
                qtyOpt.insertAdjacentHTML('beforebegin', peBannerHTML);
              }
            }
          });
        }


        var unclaimed = fleeceQty - peTopQty;
        if (unclaimed <= 0) return;

        var label = unclaimed === 1
          ? 'Select your <strong style="color:#1a1a1a;">FREE</strong> PE T-Shirt'
          : 'Select your <strong style="color:#1a1a1a;">' + unclaimed + ' FREE</strong> PE T-Shirts';

        var bannerHTML = '<a href="/products/longridge-school-pe-t-shirt?ref=pe-free" class="ribble-main-cart-pe-banner" style="display:inline-flex;align-items:center;gap:8px;padding:5px 0px;font-size:11px;font-weight:400;color:#1a1a1a;text-decoration:none;white-space:nowrap;">' +
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="#33CC66" style="flex-shrink:0"><path d="M21.41 11.58l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9A2 2 0 0 0 13 22a2 2 0 0 0 1.41-.59l7-7A2 2 0 0 0 21.41 11.58zM6.5 8A1.5 1.5 0 1 1 8 6.5 1.5 1.5 0 0 1 6.5 8z"/></svg>' +
    '<span style="text-decoration:underline;">' + label + '</span></a>';




                fleeceRows.forEach(function (row) {
          if (!row.querySelector('.ribble-main-cart-pe-banner')) {
            var qtyOpt = row.querySelector('.qtyOpt.form');
            if (qtyOpt) {
              qtyOpt.insertAdjacentHTML('beforebegin', bannerHTML);
            }
          }
        });


        // Hover bold on fleece banner links
        document.querySelectorAll('.ribble-main-cart-pe-banner').forEach(function(a) {
          a.addEventListener('mouseenter', function() { this.style.fontWeight = '700'; });
          a.addEventListener('mouseleave', function() { this.style.fontWeight = '400'; });
        });

      }); // closes .then
  } // closes initMainCartPEBanner

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMainCartPEBanner);
  } else {
    initMainCartPEBanner();
  }
})();



// Ribble PDP — Auto-scroll + Variant image jump (Glider.js)
(function () {
  function initPDPGlider() {
    var gliderEl = document.querySelector('.glider-contain .glider');
    if (!gliderEl || !gliderEl._glider) return;

    var glider = gliderEl._glider;
    var totalSlides = glider.slides ? glider.slides.length : 0;
    if (totalSlides < 2) return;

    var paused = false;

    // Auto-scroll
    setInterval(function () {
      if (paused) return;
      var next = (glider.slide + 1) % totalSlides;
      glider.scrollItem(next);
    }, 3000);

    gliderEl.addEventListener('mouseenter', function () { paused = true; });
    gliderEl.addEventListener('mouseleave', function () { paused = false; });

    // Variant colour → jump to matching slide and pause auto-scroll
    document.addEventListener('change', function (e) {
      if (!e.target || e.target.name !== 'Colour') return;

      var variantImgUrl = e.target.getAttribute('data-variant-img');
      if (!variantImgUrl) return;

      var filename = variantImgUrl.split('/').pop().split('?')[0].split('_400x400')[0];
      var slides = Array.prototype.slice.call(glider.slides);

      for (var i = 0; i < slides.length; i++) {
        var img = slides[i].querySelector('img');
        if (img && img.src && img.src.indexOf(filename) !== -1) {
          paused = true; // stop auto-scroll permanently after variant select
          glider.scrollItem(i);
          break;
        }
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initPDPGlider, 600);
    });
  } else {
    setTimeout(initPDPGlider, 600);
  }
})();

// Ribble PE Top £0 PDP — Cart-aware qty + live price revert
(function () {
  if (window.location.search.indexOf('ref=pe-free') === -1) return;

  var FLEECE_HANDLE = 'longridge-school-fleece';
  var PE_TOP_HANDLE = 'longridge-school-pe-t-shirt';

  function revertToFullPrice() {
    var priceEl = document.getElementById('ribble-price-display');
    var klarnaEl = document.getElementById('klarna-wrap');
    var badgeEl = document.getElementById('ribble-pe-free-badge');

    if (priceEl) {
      var strikeEl = priceEl.querySelector('span[style*="line-through"]');
      var originalPrice = strikeEl ? strikeEl.textContent.trim() : priceEl.textContent.trim();
      priceEl.innerHTML = '<span style="color:#1a1a1a">' + originalPrice + '</span>';
    }

    if (klarnaEl) klarnaEl.style.display = '';
    if (badgeEl) badgeEl.parentNode.removeChild(badgeEl);
  }

    function applyFreePrice() {
    var priceEl = document.getElementById('ribble-price-display');
    if (!priceEl) return;
    // Already showing £0.00 — don't re-apply
    if (priceEl.innerHTML.indexOf('£0.00') !== -1) return;
    var rawText = priceEl.textContent.trim();
    if (rawText && rawText !== '£0.00') {
      priceEl.innerHTML =
        '<span style="text-decoration:line-through;color:#999;font-weight:400;font-size:18px;margin-right:6px">' + rawText + '</span>' +
        '<span style="color:#1a1a1a">£0.00</span>';
    }
  }


  function setQty(qty) {
    var qtyInput = document.querySelector('input[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = Math.max(1, qty);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

    function checkCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fleeceQty = 0;
        var peTopQty = 0;

        cart.items.forEach(function (item) {
          if (item.handle === FLEECE_HANDLE) fleeceQty += item.quantity;
          if (item.handle === PE_TOP_HANDLE) peTopQty += item.quantity;
        });

        var unclaimed = fleeceQty - peTopQty;

        if (unclaimed <= 0) {
          revertToFullPrice();
        }
        // Always set qty to 1 regardless of unclaimed count
        setQty(1);

        return unclaimed;
      });
  }


  // Run on page load
  checkCart();

  // Re-run after add to cart form submits
  var form = document.querySelector('form[action="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function () {
      // Wait for cart to update then re-check
      setTimeout(checkCart, 800);
    });
  }

  // Also intercept fetch-based add to cart (themes that use Ajax)
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var result = origFetch.apply(this, args);
    if (url.indexOf('/cart/add') !== -1) {
      result.then(function () { setTimeout(checkCart, 500); });
    }
    return result;
  };

})();

// Fix qty button hover stroke — cart only
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cart-page .qtybtn, .ajaxified-cart .qtybtn').forEach(function(btn) {
    btn.style.setProperty('--hover_accent_color', '#444444');
  });
});

// Ribble — fix cart item-details layout
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.item-details').forEach(function(el) {
    el.style.justifyContent = 'flex-start';
    el.style.gap = '20px';
  });
});

// Ribble — T&Cs checkbox tooltip (show on button hover only when unticked)
(function () {
  function initTermsTooltip() {
    var cb = document.getElementById('cart-terms');
    var btn = document.querySelector('[data-check="true"] .btn.outline');
    if (!cb || !btn) return;

    function update() {
      if (cb.checked) {
        btn.classList.remove('terms-unticked');
      } else {
        btn.classList.add('terms-unticked');
      }
    }

    update();
    cb.addEventListener('change', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTermsTooltip);
  } else {
    initTermsTooltip();
  }
})();

// Ribble — T&Cs tooltip (Safari-safe, wraps button)
(function () {
  function initTermsTooltip() {
    var cb = document.getElementById('cart-terms');
    var btn = document.querySelector('.full-form .btn.outline');
    if (!cb || !btn) return;

    // Wrap button in a span for tooltip anchor
    var wrap = document.createElement('span');
    wrap.style.cssText = 'position:relative;display:inline-block;';
    btn.parentNode.insertBefore(wrap, btn);
    wrap.appendChild(btn);

    // Create tooltip element
    var tip = document.createElement('span');
    tip.textContent = 'Tick the box to agree to our terms & conditions';
    tip.style.cssText = 'position:absolute;top:50%;left:calc(100% + 8px);transform:translateY(-50%);background:#1a1a1a;color:#fff;font-size:12px;padding:6px 10px;border-radius:4px;white-space:nowrap;pointer-events:none;opacity:0;transition:opacity 0.2s ease;z-index:999;';
    wrap.appendChild(tip);

    function update() {
      btn.classList.toggle('terms-unticked', !cb.checked);
    }

    wrap.addEventListener('mouseenter', function () {
      if (!cb.checked) tip.style.opacity = '1';
    });
    wrap.addEventListener('mouseleave', function () {
      tip.style.opacity = '0';
    });

    cb.addEventListener('change', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTermsTooltip);
  } else {
    initTermsTooltip();
  }
})();

// Ribble — qty stepper vertical alignment + column layout
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 600) return;
  document.querySelectorAll('.qtyOpt.form').forEach(function (el) {
    el.style.setProperty('margin-top', '30px', 'important');
    el.style.setProperty('flex-direction', 'column', 'important');
    el.style.setProperty('align-items', 'center', 'important');
  });
});

// Ribble — Remove button styling
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 600) return;
  document.querySelectorAll('button.remove_item_multi').forEach(function (btn) {
    btn.style.setProperty('font-size', '13px', 'important');
    btn.style.setProperty('color', '#1a1a1a', 'important');
    btn.style.setProperty('font-weight', '500', 'important');
  });
});

// Ribble — equalise cart row heights (desktop only)
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 600) return;
  document.querySelectorAll('.item-row.product-id').forEach(function (row) {
    row.style.setProperty('align-items', 'stretch', 'important');
  });
});

// Ribble — fix total column width (desktop only)
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 600) return;
  document.querySelectorAll('.item-details h5').forEach(function (el) {
    el.style.setProperty('min-width', '120px', 'important');
    el.style.setProperty('text-align', 'left', 'important');
  });
});




